import { useState, useEffect } from 'react'
import './styles.scss'
import Package from '../package/Package.component'
import { Fade } from 'react-awesome-reveal'
import { firestore } from '../../../utils/firebase/firebase'
import { connect } from 'react-redux'
import { setLoading } from '../../../redux/system/system.actions'
import BG from '../../../assets/images/HYVEBG3.jpg'
import { Box, Button, ButtonGroup, Container, Typography } from '@mui/material'
import Page from '../../../components/page/Page'
import Span from '../../../components/Span'
import DayPasses from './DayPasses.component'

function Packages({ setLoading }) {
  const [membershipType, setMembershipType] = useState('individual')
  const [hyveMemberships, setHyveMemberships] = useState([])

  const sortedMemberships = hyveMemberships.sort(function (a, b) {
    return a.order - b.order
  })

  const filteredMemberships = sortedMemberships
    .filter((m) => m.enabled !== false)
    .filter((m) => (m.type || 'individual') === membershipType)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      const data = []
      firestore
        .collection('memberships')
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc, index) => data.push(doc.data()))
          setHyveMemberships(data)
          setLoading(false)
        })
        .catch((error) => {
          console.log('Data error', error)
        })
    }
    fetchData()
  }, [setLoading])

  return (
    <Page container={false}>
      <Fade>
        <Box
          style={{
            backgroundImage: `linear-gradient(270deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 1)), url(${BG})`,
            minHeight: '89vh',
            paddingTop: 20,
          }}
        >
          <Container maxWidth='xl'>
            <Typography variant='h2' color={'white.main'}>
              Get
            </Typography>
            <Typography variant='h2' color='white.main' mb={3}>
              <Span>involved</Span>.
            </Typography>
            <Box
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
            >
              <Box
                display={'flex'}
                alignItems={'center'}
                flexDirection={'column'}
              >
                <Typography variant='h6' color='white.main'>
                  Select a membership type
                </Typography>
                <ButtonGroup
                  size='large'
                  aria-label='large button group'
                  sx={{ mt: 2 }}
                >
                  <Button
                    variant={
                      membershipType === 'individual' ? 'contained' : 'outlined'
                    }
                    onClick={() => setMembershipType('individual')}
                  >
                    Individual
                  </Button>
                  <Button
                    variant={
                      membershipType === 'family' ? 'contained' : 'outlined'
                    }
                    onClick={() => setMembershipType('family')}
                  >
                    Family
                  </Button>
                </ButtonGroup>
              </Box>

              <Box
                display={'flex'}
                flexWrap={'wrap'}
                justifyContent={'center'}
                alignItems={'stretch'}
                width='100%'
                maxWidth={1140}
                mx={'auto'}
                gap={3}
                mt={5}
                mb={4}
                px={{ xs: 1, sm: 2 }}
              >
                {filteredMemberships.map((membership) => (
                  <Package membership={membership} key={membership.stripeAPI} />
                ))}
              </Box>

              {membershipType === 'individual' && (
                <Box
                  width='100%'
                  maxWidth={720}
                  mx={'auto'}
                  mb={5}
                  px={{ xs: 2.5, sm: 3 }}
                  py={2.5}
                  sx={{
                    border: (theme) =>
                      `1px solid ${theme.palette.primary.main}55`,
                    borderRadius: 2,
                    background:
                      'linear-gradient(180deg, rgba(211,185,8,0.08) 0%, rgba(20,20,20,1) 100%)',
                    textAlign: 'center',
                  }}
                >
                  <Typography variant='h6' color='primary' mb={1.5}>
                    Blue Light, Senior or Student?
                  </Typography>
                  <Typography color='white.main' lineHeight={1.6} mb={1}>
                    Gym only? Pick the <Span>Gym Only Concession</Span> tier
                    above. The discount is already applied, so you can join
                    online right now.
                  </Typography>
                  <Typography color='white.main' lineHeight={1.6}>
                    For discounted <Span>Hyrox</Span> or <Span>CrossFit</Span>,
                    join at the full price above, then contact us and we'll
                    apply your discount.
                  </Typography>
                </Box>
              )}

              <DayPasses />
            </Box>
          </Container>
        </Box>
      </Fade>
    </Page>
  )
}

const mapDispatchToProps = (dispatch) => ({
  setLoading: (system) => dispatch(setLoading(system)),
})

export default connect(null, mapDispatchToProps)(Packages)
